import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzRt } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_RT: Record<
  Exclude<PageIdWoofzRt, PageIdWoofzRt.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SEX_RT_2_RTV2]: {
    hasHeader: true,
    id: PageId.SEX_RT_2_RTV2,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_AGE_RT_RTV2]: {
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    id: PageId.DOG_AGE_RT_RTV2,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_V1_RTV2]: {
    id: PageId.URGE_RT_V1_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.CHALLENGES_RT_RTV2]: {
    id: PageId.CHALLENGES_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.WALKS_FEEL_RTV2]: {
    id: PageId.WALKS_FEEL_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_EXCITEMENTS_TRIGGERS_RTV2]: {
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
    id: PageId.DOG_EXCITEMENTS_TRIGGERS_RTV2,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_5_RTV2]: {
    id: PageId.URGE_RT_5_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.DOG_MISBEHAVES_RTV2]: {
    id: PageId.DOG_MISBEHAVES_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_ACT_RT_RTV2]: {
    id: PageId.DOG_ACT_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_OFF_AT_HOME_RTV2]: {
    id: PageId.DOG_OFF_AT_HOME_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_6_RTV2]: {
    id: PageId.URGE_RT_6_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.ACCESS_TO_FOOD_RTV2]: {
    id: PageId.ACCESS_TO_FOOD_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_7_RTV2]: {
    id: PageId.URGE_RT_7_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.DOG_AGGRESSIVE_RT_RTV2]: {
    id: PageId.DOG_AGGRESSIVE_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_CALM_DOWN_RT_RTV2]: {
    id: PageId.DOG_CALM_DOWN_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_8_RTV2]: {
    id: PageId.URGE_RT_8_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.DOG_BREED_RT_RTV2]: {
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_RT,
    id: PageId.DOG_BREED_RT_RTV2,
  },
  [PageId.URGE_RT_9_RTV2]: {
    id: PageId.URGE_RT_9_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.COMMANDS_61_RT_RTV2]: {
    id: PageId.COMMANDS_61_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.COMMANDS_62_RT_RTV2]: {
    id: PageId.COMMANDS_62_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.COMMANDS_63_RT_RTV2]: {
    id: PageId.COMMANDS_63_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_10_RTV2]: {
    id: PageId.URGE_RT_10_RTV2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.URGE_LOADER_RT_RTV2]: {
    id: PageId.URGE_LOADER_RT_RTV2,
    hasHeader: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.DOG_STATISTICS_RT_RTV2]: {
    id: PageId.DOG_STATISTICS_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.TRAINING_RT_RTV2]: {
    id: PageId.TRAINING_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_RT,
  },
  [PageId.PREPARE_FLOW_RT_RTV2]: {
    id: PageId.PREPARE_FLOW_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.EMAIL_RT_RTV2]: {
    id: PageId.EMAIL_RT_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.NEWSLETTER_URGE_RTV2]: {
    id: PageId.NEWSLETTER_URGE_RTV2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.URGE_RT_4_RTV2]: {
    id: PageId.URGE_RT_4_RTV2,
    hasHeader: true,
    theme: THEMES.VARIANT_RT,
  },
  [PageId.LAST_CHANCE_OFFER_RT_V2_RTV2]: {
    id: PageId.LAST_CHANCE_OFFER_RT_V2_RTV2,
  },
  [PageId.SUBSCRIPTIONS_RT_RTV2]: {
    hasHeader: false,
    id: PageId.SUBSCRIPTIONS_RT_RTV2,
  },
  [PageId.CHAT_UPSELL_RTV2]: {
    hasHeader: true,
    id: PageId.CHAT_UPSELL_RTV2,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_1_RTV2]: {
    hasHeader: true,
    id: PageId.UPSELL_1_RTV2,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PITPAT_RTV2]: {
    id: PageId.UPSELL_PITPAT_RTV2,
  },
  [PageId.DOWNLOAD_RTV2]: {
    hasHeader: true,
    id: PageId.DOWNLOAD_RTV2,
    theme: THEMES.POLICY,
  },
}
